import qoalaStorage from '~/core/Storage';
import { parseIfJsonString } from '~/core/helper/JSONHelper';

export default {
  getHealthPurchaseHistory: state => {
    return qoalaStorage.getItem('healthPurchaseHistory')
      ? parseIfJsonString(qoalaStorage.getItem('healthPurchaseHistory'))
      : state.healthPurchaseHistory;
  },
  getType: state => {
    return qoalaStorage.getItem('protectionType')
      ? parseIfJsonString(qoalaStorage.getItem('protectionType'))
      : state.type;
  },
  getCovered: state => {
    return qoalaStorage.getItem('covered') ? parseIfJsonString(qoalaStorage.getItem('covered')) : state.covered;
  },
  getSelfData: state => {
    return qoalaStorage.getItem('selfData') ? parseIfJsonString(qoalaStorage.getItem('selfData')) : state.selfData;
  },
  getSpouseData: state => {
    return qoalaStorage.getItem('spouseData')
      ? parseIfJsonString(qoalaStorage.getItem('spouseData'))
      : state.spouseData;
  },
  getSonData: state => {
    return qoalaStorage.getItem('sonData') ? parseIfJsonString(qoalaStorage.getItem('sonData')) : state.sonData;
  },
  getDaughterData: state => {
    return qoalaStorage.getItem('daughterData')
      ? parseIfJsonString(qoalaStorage.getItem('daughterData'))
      : state.daughterData;
  },
  getListProduct: state => {
    const listProduct = qoalaStorage.getItem('healthProduct')
      ? parseIfJsonString(qoalaStorage.getItem('healthProduct'))
      : state.listProduct;
    return listProduct || [];
  },
  getProductDetail: state => {
    return qoalaStorage.getItem('productDetailHealth')
      ? parseIfJsonString(qoalaStorage.getItem('productDetailHealth'))
      : state.productDetail;
  },
  getPayload: state => {
    return qoalaStorage.getItem('healthPayload')
      ? parseIfJsonString(qoalaStorage.getItem('healthPayload'))
      : state.payload;
  }
};
